// src/api/queryClient.ts
import { QueryClient } from 'react-query';
import { redirectToLogin } from '../components/router/redirect';

const isAuthError = (error: unknown) => {
    return (
        error instanceof Error &&
        "response" in error &&
        (error as any).response?.status === 401
    );
};

const handleAuthError = () => {
    localStorage.removeItem("ACCESS_TOKEN");
    redirectToLogin();
};

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            cacheTime: 5 * 60 * 1000,
            onError: (error) => {
                if (isAuthError(error)) {
                    handleAuthError();
                }
            },
        },
        mutations: {
            onError: (error) => {
                if (isAuthError(error)) {
                    handleAuthError();
                }
            },
        },
    },
});
